module.exports = __webpack_public_path__ + "static/media/BIM Collaborate.5a2e0d38.png";